import { toast } from "react-toastify";

export const toastDefaults = {
  autoClose: 3000,
  theme: "colored",
  closeOnClick: true,
  pauseOnFocusLoss: true,
  draggable: true,
};

/** Error and warning toasts stay until the user dismisses them. */
const persistentTypes = ["error", "warning"];

export const showToast = (type = "info", message = "", options = {}) => {
  const fn = toast[type] || toast.info;
  const baseOpts = { toastId: message, ...toastDefaults, ...options };
  const opts = persistentTypes.includes(type) ? { ...baseOpts, autoClose: false } : baseOpts;
  return fn(message, opts);
};
